export enum Role {
  Root = 'Root',
  Admin = 'Admin',
  Manager = 'Manager',
  ViewOnly = 'ViewOnly',
}
